module.exports = __webpack_public_path__ + "static/media/undraw_version_control_9bpv.100a69eb.svg";